module.exports = __webpack_public_path__ + "img/3.0ec9efb6.jpg";